'use strict';

const accordion = (function() {
  const activeClass = 'is-active';
  /**
   *
   * @param el - target element
   * @param trigger - accordion trigger
   */
  function showContent(el, trigger) {
    el.classList.add(activeClass);
    el.setAttribute('aria-hidden', 'false');
    trigger.setAttribute('aria-expanded', 'true');
    trigger.classList.add(activeClass);
  }
  /**
   *
   * @param el - target element
   * @param trigger - accordion trigger
   */
  function hideContent(el, trigger) {
    trigger.setAttribute('aria-expanded', 'false');
    trigger.classList.remove(activeClass);
    el.classList.remove(activeClass);
    el.setAttribute('aria-hidden', 'true');
  }
  /**
   *
   * @param e - click event
   */
  function toggle(e) {
    e.preventDefault();
    const triggerEl = e.currentTarget;
    const contentSelector = triggerEl.getAttribute('data-target');
    const contentEl = document.getElementById(contentSelector);
    if (!contentEl.classList.contains(activeClass)) {
      showContent(contentEl, triggerEl);
    } else {
      hideContent(contentEl, triggerEl);
    }
  }
  /**
   *
   * @param trigger - trigger element
   * @param content - content to hide
   */
  function updateAccessibilityAttributes(trigger, content) {
    if (content.classList.contains(activeClass)) {
      trigger.setAttribute('aria-expanded', 'true');
      content.setAttribute('aria-hidden', 'false');
    } else {
      trigger.setAttribute('aria-expanded', 'false');
      content.setAttribute('aria-hidden', 'true');
    }
    content.setAttribute('aria-labelledby', trigger.id);
  }
  /**
   *
   * @param item - instance of accordion group
   * @param index - current index of forEach
   */
  function init(item, index) {
    const trigger = item.querySelector('.accordion__trigger');
    const content = item.querySelector('.accordion__content');

    if (!trigger || !content) return;

    trigger.id = `accordion-trigger-${index}`;
    trigger.setAttribute('data-target', `accordion-content-${index}`);
    content.id = `accordion-content-${index}`;
    content.setAttribute('data-accodrion', index);
    updateAccessibilityAttributes(trigger, content);
    trigger.addEventListener('click', toggle);
  }
  window.addEventListener('DOMContentLoaded', () => {
    const accordions = document.querySelectorAll('.accordion');
    if (accordions) {
      [].forEach.call(accordions, (item, index) => init(item, index));
    }
  });
})();

export default accordion;
